import 'react-placeholder/lib/reactPlaceholder.css';
import {
  RectShape,
  TextBlock,
  TextRow,
} from 'react-placeholder/lib/placeholders';

export default function DetalhePedidoSkeleton() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
      <RectShape
        color='rgb(205, 205, 205)'
        style={{ width: '100%', height: '200px' }}
      />
      <TextRow color='rgb(205, 205, 205)' style={{ width: '100%' }} />
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <TextRow color='rgb(205, 205, 205)' style={{ width: '200px' }} />
        <TextRow color='rgb(205, 205, 205)' style={{ width: '100px' }} />
      </div>
      <TextBlock rows={3} color='rgb(205, 205, 205)' style={{ width: '30%' }} />
      <div style={{ display: 'flex', gap: '100px' }}>
        <TextBlock
          rows={3}
          color='rgb(205, 205, 205)'
          style={{ width: '20%' }}
        />
        <TextBlock
          rows={3}
          color='rgb(205, 205, 205)'
          style={{ width: '20%' }}
        />
      </div>
      <TextBlock
        rows={4}
        color='rgb(205, 205, 205)'
        style={{ width: '100%' }}
      />
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-end',
        }}>
        <div style={{ display: 'flex', gap: '20px', flexDirection: 'column' }}>
          <TextRow color='rgb(205, 205, 205)' style={{ width: '100px' }} />
          <div id='tempo-de-entrega' style={{ display: 'flex' }}>
            <RectShape
              color='rgb(205, 205, 205)'
              style={{ width: '80px', height: '30px' }}
            />
            <RectShape
              color='rgb(205, 205, 205)'
              style={{ width: '80px', height: '30px' }}
            />
            <RectShape
              color='rgb(205, 205, 205)'
              style={{ width: '80px', height: '30px' }}
            />
            <RectShape
              color='rgb(205, 205, 205)'
              style={{ width: '80px', height: '30px' }}
            />
          </div>
        </div>
        <div style={{ display: 'flex' }}>
          <RectShape
            color='rgb(205, 205, 205)'
            style={{ width: '80px', height: '30px' }}
          />
          <RectShape
            color='rgb(205, 205, 205)'
            style={{ width: '80px', height: '30px' }}
          />
        </div>
      </div>
    </div>
  );
}
